import NameAndLogo from 'pages/ClinicSettings/NameAndLogo/NameAndLogo';



export default NameAndLogo;
